<template>
    <f7-page
        no-navbar
        navbar-hidden
        no-swipeback
        class="onboardingBg"
    >
        <div
            v-if="onboardingCompleted < 2"
            style="padding: 360px 36px 36px;"
        >
            Complete the introduction to get started
            <!-- &rarr; -->
        </div>
        <div
            v-else
            id="menuBlock"
        >

            <div class="menuList2 list no-hairlines no-hairlines-between">
                <ul>
                    <f7-list-item
                        :link="'/home'"
                        :animate="false"
                        reload
                        no-chevron
                        view="#main"
                    >
                        Home</f7-list-item>
                    <f7-list-item
                        :link="'/explore/'"
                        :animate="false"
                        reload
                        no-chevron
                        view="#main"
                    >Learn</f7-list-item>
                    <f7-list-item
                        :link="'/explore/play'"
                        :animate="false"
                        reload
                        no-chevron
                        view="#main"
                    >{{ play }}</f7-list-item>
                    <f7-list-item
                        :link="'/explore/listen'"
                        :animate="false"
                        reload
                        no-chevron
                        view="#main"
                    >Listen</f7-list-item>
                    <f7-list-item
                        :link="'/explore/ask'"
                        :animate="false"
                        reload
                        no-chevron
                        view="#main"
                    >{{ ask }}</f7-list-item>
                    <f7-list-item
                        :link="'/profile/'"
                        :animate="false"
                        reload
                        no-chevron
                        view="#main"
                    >My Profile
                        <span
                            v-if="unreadEventsPlusPulse"
                            class="badge color-red"
                            style="padding-top: 4px;margin-left: 10px;"
                        >{{ unreadEventsPlusPulse }}</span>
                    </f7-list-item>
                </ul>
            </div>

        </div>

    </f7-page>
</template>

<script>
export default {
    store: ['api', 'user', 'unreadEvents', 'onboardingCompleted', 'trackerData'],
    data () {
        return {
            variant: 0,
            play: 'Play',
            ask: 'Ask',
        };
    },
    computed: {
        unreadEventsPlusPulse: function () {
            return this.unreadEvents + (this.onboardingCompleted > 0 && this.trackerData.timeForTracker ? 1 : 0);
        }
    },
    created: function () {
        this.variant = parseFloat(localStore.getItem(`experiment-016_explore-names`));
        if (this.variant === 1) {
            this.play = 'Exercise';
        }
        if (this.variant === 2) {
            this.ask = 'Discuss';
        }
    },
    methods: {
        logout: function () {
            window.localStore.clear();
            window.location.href = '/app';
        }
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
.menuList2.list,
.menuList3.list {
    font-size: 22px !important;
    padding-left: 30px;
    ul {
        background: transparent !important;
    }
    margin: 0;
    max-width: 220px;
    background: transparent !important;
    li {
        background: transparent !important;
    }
    li:hover {
        i {
            color: @coral;
        }
    }
    cursor: pointer;
}
.menuList3.list {
    padding-left: 50px;
}
#menuBlock {
    margin: 40px 0 0 0;
}
@media only screen and (min-height: 800px) {
    #menuBlock {
        margin: -20px 0 0 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
}
</style>
